import { useState, useEffect, PropTypes } from "react";
import Header from "../common/header/DefaultHeader";
import MobileMenu from "../common/header/MobileMenu";
import PopupSignInUp from "../common/PopupSignInUp";
import "./FeaturesHelpTopic.css";
import { useLocation, useNavigate } from "react-router";
import "./FaqDetails.css";
import OtherLinkFooter from "../common/footer/OtherLinkFooter";
import NewFooter from "../common/footer/NewFooter";

const FaqDetails = () => {
  const location = useLocation();
  const { topic } = location.state;
  const [getOpenThanksModel, setOpenThanksModel] = useState(true);
  const [getDescribeInfo, setDescribeInfo] = useState(false);
  const [getCustomerCareInfo, setCustomerCareInfo] = useState(false);
  const [speakCustomerCare, setSpeakCustomerCare] = useState(false);
  const [isLiked, setIsLiked] = useState([
    {
      id: 1,
      value: true,
      name: "This information was confusing",
      selected: true,
    },
    {
      id: 2,
      value: false,
      name: "This isn’t the information I was looking for",
      selected: false,
    },
  ]);

  const handleFeedbackAlert = () => {
    setOpenThanksModel(false);
    setDescribeInfo(true);
  };

  const handleSpeakWithCustomerCare = () => {
    setSpeakCustomerCare(true);
  };

  const handleFeedbackCustomerCare = () => {
    setDescribeInfo(false);
    setOpenThanksModel(false);
    setCustomerCareInfo(true);
  };

  let navigate = useNavigate();

  const handleBackToSupportPage = () => {
    navigate("/support");
  };

  const onRadioBtnClick = (item) => {
    let updatedState = isLiked.map((isLikedItem) =>
      isLikedItem.id === item.id
        ? { ...isLikedItem, selected: true }
        : { ...isLikedItem, selected: false }
    );
    setIsLiked(updatedState);
  };
  console.log("topic--->>", topic);
  return (
    <>
      {/* <!-- Main Header Nav --> */}
      <Header />

      {/* <!--  Mobile Menu --> */}
      <MobileMenu />

      {/* <!-- Modal --> */}
      <PopupSignInUp />

      {/* <!-- Inner Page Breadcrumb --> */}
      <section>
        <div className="top-banner">
          <img src="https://image-prod.hubzu.com/banner/Banner.png"></img>
        </div>
        <div className="backbutton">
          <a href="/support" className="faq-backToHome">
            <svg
              className="faq-btn-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="7"
              height="14"
              viewBox="0 0 7 14"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.84182 0.821257C5.79253 0.768926 5.72382 0.739258 5.65193 0.739258C5.58004 0.739258 5.51133 0.768926 5.46204 0.821257L5.28794 1.00608L0.158436 6.45161L-0.0156636 6.63643L-0.189763 6.82126C-0.284402 6.92173 -0.284402 7.07853 -0.189763 7.179L-0.0156636 7.36382L0.158436 7.54865L5.28794 12.9942L5.46204 13.179C5.51133 13.2313 5.58004 13.261 5.65193 13.261C5.72382 13.261 5.79253 13.2313 5.84182 13.179L6.19002 12.8093C6.28466 12.7089 6.28466 12.5521 6.19002 12.4516L6.01592 12.2668L1.0549 7.00013L6.01592 1.73347L6.19002 1.54865C6.28466 1.44818 6.28466 1.29138 6.19002 1.19091L5.84182 0.821257Z"
                fill="#118BF4"
              ></path>
              <path
                d="M5.84182 0.821257L6.03171 0.642387L6.03171 0.642386L5.84182 0.821257ZM5.46204 0.821257L5.27215 0.642386L5.27215 0.642386L5.46204 0.821257ZM5.28794 1.00608L5.09805 0.827212V0.827212L5.28794 1.00608ZM0.158436 6.45161L0.348326 6.63048L0.348326 6.63048L0.158436 6.45161ZM-0.0156636 6.63643L-0.205553 6.45756L-0.205554 6.45756L-0.0156636 6.63643ZM-0.189763 6.82126L-0.379653 6.64239H-0.379653L-0.189763 6.82126ZM-0.189763 7.179L0.000127733 7.00013L0.000126958 7.00013L-0.189763 7.179ZM-0.0156636 7.36382L-0.205554 7.54269L-0.205553 7.54269L-0.0156636 7.36382ZM0.158436 7.54865L0.348326 7.36978L0.348326 7.36978L0.158436 7.54865ZM5.28794 12.9942L5.09805 13.173H5.09805L5.28794 12.9942ZM5.46204 13.179L5.65193 13.0001H5.65193L5.46204 13.179ZM5.84182 13.179L6.03171 13.3579L5.84182 13.179ZM6.19002 12.8093L6.37991 12.9882L6.19002 12.8093ZM6.19002 12.4516L6.37991 12.2727H6.37991L6.19002 12.4516ZM6.01592 12.2668L5.82603 12.4457H5.82603L6.01592 12.2668ZM1.0549 7.00013L0.865014 6.82126C0.770375 6.92173 0.770375 7.07853 0.865014 7.179L1.0549 7.00013ZM6.01592 1.73347L5.82603 1.5546V1.5546L6.01592 1.73347ZM6.19002 1.54865L6.37991 1.72752V1.72752L6.19002 1.54865ZM6.19002 1.19091L6.37991 1.01204V1.01204L6.19002 1.19091ZM5.65193 1.00013L5.65193 1.00013L6.03171 0.642386C5.93312 0.537725 5.79571 0.478388 5.65193 0.478388V1.00013ZM5.65193 1.00013L5.65193 1.00013V0.478388C5.50815 0.478388 5.37074 0.537725 5.27215 0.642386L5.65193 1.00013ZM5.47783 1.18495L5.65193 1.00013L5.27215 0.642386L5.09805 0.827212L5.47783 1.18495ZM0.348326 6.63048L5.47783 1.18495L5.09805 0.827212L-0.0314546 6.27274L0.348326 6.63048ZM0.174226 6.8153L0.348326 6.63048L-0.0314541 6.27274L-0.205553 6.45756L0.174226 6.8153ZM-0.205554 6.45756L-0.379653 6.64239L0.000127345 7.00013L0.174227 6.8153L-0.205554 6.45756ZM0.000126958 7.00013L0.000127345 7.00013L-0.379653 6.64239C-0.568931 6.84333 -0.568932 7.15693 -0.379653 7.35787L0.000126958 7.00013ZM0.174227 7.18495L0.000127733 7.00013L-0.379653 7.35787L-0.205554 7.54269L0.174227 7.18495ZM0.348326 7.36978L0.174226 7.18495L-0.205553 7.54269L-0.0314541 7.72752L0.348326 7.36978ZM-0.0314546 7.72752L5.09805 13.173L5.47783 12.8153L0.348326 7.36978L-0.0314546 7.72752ZM5.09805 13.173L5.27215 13.3579L5.65193 13.0001L5.47783 12.8153L5.09805 13.173ZM5.27215 13.3579C5.37074 13.4625 5.50814 13.5219 5.65193 13.5219V13.0001L5.27215 13.3579ZM5.65193 13.5219C5.79571 13.5219 5.93312 13.4625 6.03171 13.3579L5.65193 13.0001V13.5219ZM6.03171 13.3579L6.37991 12.9882L6.00013 12.6305L5.65193 13.0001L6.03171 13.3579ZM6.37991 12.9882C6.56919 12.7873 6.56919 12.4737 6.37991 12.2727L6.00013 12.6305L6.37991 12.9882ZM6.37991 12.2727L6.20581 12.0879L5.82603 12.4457L6.00013 12.6305L6.37991 12.2727ZM6.20581 12.0879L1.24479 6.82126L0.865014 7.179L5.82603 12.4457L6.20581 12.0879ZM5.82603 1.5546L0.865014 6.82126L1.24479 7.179L6.20581 1.91234L5.82603 1.5546ZM6.00013 1.36978L5.82603 1.5546L6.20581 1.91234L6.37991 1.72752L6.00013 1.36978ZM6.00013 1.36978V1.36978L6.37991 1.72752C6.56919 1.52658 6.56919 1.21298 6.37991 1.01204L6.00013 1.36978ZM5.65193 1.00013L6.00013 1.36978L6.37991 1.01204L6.03171 0.642387L5.65193 1.00013Z"
                fill="#118BF4"
              ></path>
            </svg>
            <span className="faq-backToHomeBtn">Back to FAQs</span>
          </a>
        </div>
        {/* </section> */}
        {/* <section className="featuredTopicList"> */}
        <div className="featuredquesand">
          <div className="featuredtopicQues">{topic.question}</div>
          <div className="featuredtopicAns">{topic.answer}</div>
        </div>
      </section>
      {getOpenThanksModel && (
        <section className="helpfulbox">
          <div className="container">
            <div className="card feedbackcard">
              <div className="card-body">
                <h5 className="card-title">Was this Information Helpful?</h5>
                <div id="btn-cont" className="btn-cont">
                  <button
                    className="btn btn-primary"
                    type="submit"
                    id="yesBtn"
                    onClick={() => setOpenThanksModel(false)}
                  >
                    Yes
                  </button>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    id="noBtn"
                    onClick={() => handleFeedbackAlert()}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {!getOpenThanksModel && !getDescribeInfo && !getCustomerCareInfo && (
        <div className="container response">
          <div className="card feedbackcard">
            <div className="card-body">
              <h5 className="card-title">Thank you for your feedback!</h5>
            </div>
          </div>
        </div>
      )}

      {getDescribeInfo && (
        <div className="container response">
          <div className="card feedbackcard">
            <div className="card-body">
              <h5 className="card-title">
                What best describes the information we provided?
              </h5>
              {isLiked.map((item) => (
                <div className="form-check" key={item.id}>
                  <input
                    className="form-check-input descriptionbtntext"
                    type="radio"
                    name="flexRadioDefault"
                    id={`flexRadioDefault${item.id}`}
                    checked={item.selected}
                    onClick={() => onRadioBtnClick(item)}
                  />
                  <label
                    className="form-check-label informationtext"
                    htmlFor="flexRadioDefault"
                  >
                    {item.name}
                  </label>
                </div>
              ))}
              <div className="col-auto">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={() => handleFeedbackCustomerCare()}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {getCustomerCareInfo && !speakCustomerCare && (
        <div className="container response">
          <div className="card feedbackcard">
            <div className="card-body searchagainsection">
              <h5 className="card-title">
                {" "}
                Thank you for your feedback. Still have questions?
              </h5>
              <button
                className="btn btn-primary"
                type="submit"
                id="noBtn"
                onClick={() => handleBackToSupportPage()}
              >
                Search Again
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                id="noBtn"
                onClick={() => openActionSheet()}
              >
                Chat with customer care
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                id="noBtn"
                onClick={() => handleSpeakWithCustomerCare()}
              >
                Speak with customer care
              </button>
            </div>
          </div>
        </div>
      )}

      {speakCustomerCare && (
        <div className="container response">
          <div className="card feedbackcard">
            <div className="card-body">
              <h5 className="card-title">
                You can reach our Customer Care team at (855) 882-1314, Monday
                to Friday between the hours of 7 AM and 7 PM EDT.
              </h5>
              <button
                className="btn btn-primary"
                type="submit"
                id="noBtn"
                onClick={() => handleBackToSupportPage()}
              >
                Search Again
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                id="noBtn"
                onClick={() => openActionSheet()}
              >
                Chat with customer care
              </button>
            </div>
          </div>
        </div>
      )}

      {/* <!-- Our Footer --> */}
      {/* <section className="footer_one">
        <div className="container">
          <div className="row">
            <Footer />
          </div>
        </div>
      </section> */}
      <div className="container-fluid px-0">
        {/* <Footer /> */}
        <OtherLinkFooter />
        <NewFooter />
      </div>
    </>
  );
};

export default FaqDetails;
